import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledCardCarousel = styled.div`
  .minicardlink {
    width: 100%;
  }

  @media (min-width: 767px) and (max-width: 991px) {
    .minicardlink {
      width: 720px;
    }
  }
  .minicardcontiner {
    background: white;
    width: auto;
    height: 100%;
    .miniCardImage {
      width: 100%;
      object-fit: cover;
      height: 100%;
      min-height: 6.25rem;
    }
  }
  .containerli {
    &:first-child {
      margin-left: 0 !important;
    }
  }
  .lt-link,
  .lt-link-container > div > div > div {
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: var(--color-white);
    position: relative;
    border-radius: 0 !important;
  }
  @media (min-width: 992px) {
    .lt-link,
    .lt-link-container > div > div > div {
      flex: 1 1 50%;
      padding: 0;
    }
  }
  .lt-link picture,
  .lt-link-container > div > div > div picture {
    flex: 0 0 108px;
    height: 100%;
    align-content: center;
  }
  @media (min-width: 992px) {
    .lt-link picture,
    .lt-link-container > div > div > div picture {
      flex: 0 1 108px;
      align-content: center;
    }
  }
  .lt-link h3,
  .lt-link-container > div > div > div h3 {
    flex: 1;
    font-weight: 700;
    margin: 0;
    max-width: 370px;
    text-wrap: balance;
    font-size: 18px;
    line-height: 22px;

    @media (max-width: 576px) {
      max-width: 320px;
    }
    @media (max-width: 991px) {
      max-width: 500px;
    }
  }
  @media (max-width: 991px) {
    .lt-link h3,
    .lt-link-container > div > div > div h3 {
      font-size: 16px;
    }
  }
  .lt-link svg,
  .lt-link-container > div > div > div svg {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 20px !important;
  }
  .carousal_header {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    .heading_container {
      position: relative;
      top: 12px;
    }
    .carousal_header--cta {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      margin-bottom: ${toRem(8)};
    }
  }
  .glide__slides {
    @media (max-width: 991px) {
      flex-direction: column;
      gap: 20px;
      li {
        margin-left: 0 !important;
      }
    }
  }
  .glide {
    &__track {
      padding-top: ${toRem(24)};
      .glide__slides_authoring {
        width: 110% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        .aem-container {
          padding: 0;
        }
      }
    }
    &__track__pt3 {
      overflow: hidden;
      padding-top: ${toRem(8)};
      .glide__slides_authoring {
        width: 110% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        .aem-container {
          padding: 0;
        }
      }
    }
    .center-align {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .glide--swipeable {
    cursor: default;
  }
  .full-width-cards-controls {
    display: none;
  }
  [class*='icon-arrow-'][class*='-external']::before {
    right: 20px !important;
    content: '\e922';
  }
  [class*='icon-arrow-'][class*='-external']:hover::before {
    transform: unset;
    transition: none;
    content: '\e922';
    right: 20px !important;
    font-weight: 500;
  }
  .carouselControlType1 .right-arrow.glide__arrow2,
  .carouselControlType1 .left-arrow.glide__arrow2 {
    background: 0;
    color: var(--color-black);
    text-transform: none;
    box-shadow: none;
    position: relative;
    font-size: 13px;
    line-height: 15px;
    padding: 0 10px;

    left: auto;
    right: auto;
    top: auto;
    bottom: auto;
    transform: none;
    span {
      font-size: 24px;
    }

    &:hover {
      color: var(--color-black);
      box-shadow: none;
      background-color: transparent;
    }
  }

  .miniCardContent .miniCardBody {
    padding-right: 0;
    margin-bottom: 0;
    width: auto;
  }

  .miniCardContent .miniCardBody .clampLines {
    display: -webkit-box;
    -webkit-line-clamp: none;
    -webkit-box-orient: vertical;
    white-space: normal;
    margin-bottom: 0;
  }
`;
